/** Member JWT + profile keys in localStorage (shared by api + auth; no axios imports). */

export const MEMBER_TOKEN_KEYS = ['access_token', 'refresh_token'];
export const MEMBER_USER_KEY = 'user';

export function clearMemberStorage() {
  [...MEMBER_TOKEN_KEYS, MEMBER_USER_KEY].forEach((key) =>
    localStorage.removeItem(key)
  );
}
